import React, { useEffect } from 'react'
import { useAppContext } from '../../../app/AppContext'
import { useNavigate } from "react-router-dom";
import LoginPage from './components/LoginPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
// import Home from '../Home';

export default function RoutesMenusLogin() {

    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();
    useEffect(() => {
        addMenu({ uid: "loginPage", text: "Login", iconName: "Login", action: () => { navigate("/login") }, })
        addRoute({ uid: "loginPage", title: "Login", route: "/login", element: <LoginPage /> })
        addRoute({ uid: "forgotPasswordPage", title: "Forgot Password", route: "/forgot-password", element: <ForgotPasswordPage /> })
        //  addRoute({ uid: "homeStart", title: "Início", route: "/", element: <Home /> });
        return () => { removeMenusRoutes('loginPage', 'homeStart') }
    }, [addMenu, addRoute, navigate, removeMenusRoutes])

    return (<></>)
}
